/* Progressive enhancement. Shopify handles commerce; no shadow cart or customer data. */
(() => {
 'use strict';

 /* Product routing, not a clinical assessment. Product details come from Liquid. */
 function chooseChew(weight,style,preference,catalog) {
  if(!Number.isFinite(weight)||weight<5||weight>300)return null;
  const species=preference==='deer'?'deer':'elk';
  const cut=style==='strong'?'whole':'split';
  let rank=weight<=15?0:weight<=30?1:weight<=70?2:3;
  // Split Elk has its own published Medium range. At 45 lb, move to Large.
  if(species==='elk'&&cut==='split'&&weight>15&&weight<45)rank=1;
  const sizes=['small','medium','large','xl'];
  const wanted=`${species}_${cut}_${sizes[rank]}`;
  let chosen=catalog.find(p=>p.key===wanted),substitution='';
  // There is no Small Split or XL Split Deer in the current assortment.
  if(!chosen&&species==='deer'&&cut==='split'&&(rank===0||rank===3)) {
   chosen=catalog.find(p=>p.key===`elk_split_${sizes[rank]}`);
   substitution=rank===0
    ?'There is no Small Split Deer in this assortment, so we recommend Small Split Elk to keep the split cut in the smaller size.'
    :'There is no extra-large Split Deer in this assortment, so we recommend Jumbo Split Elk rather than a smaller Deer chew.';
  }
  // A removed product can only fall back to the same cut and an equal/larger size.
  // Never silently recommend a smaller chew, or swap Split to Whole.
  if(!chosen) {
   const alternatives=catalog.filter(p=>p.cut.toLowerCase()===cut&&p.rank>=rank)
    .sort((a,b)=>(a.rank-rank)-(b.rank-rank)||
      Number(b.species.toLowerCase()===species)-Number(a.species.toLowerCase()===species)||
      a.key.localeCompare(b.key));
   chosen=alternatives[0];
   if(chosen)substitution='The matching product is not currently listed. This is the closest listed option in the same cut, without moving to a smaller size.';
  }
  if(!chosen)return null;
  const whyCut=cut==='whole'
   ?'The Whole cut keeps the outer structure intact for your stronger, more experienced chewer.'
   :'The Split cut exposes the marrow center for a light, moderate, or first-time antler chewer.';
  let whySize=`For a ${weight.toLocaleString()} lb dog, the finder selects ${chosen.size}.`;
  if(weight>30&&weight<45&&chosen.rank===2)whySize+=' In this in-between weight band, it moves up to Large rather than down to Medium.';
  if(weight>15&&weight<45&&chosen.key==='elk_split_medium')whySize+=' Medium Split Elk covers the product-specific 15-45 lb range; the finder moves to Large at 45 lb.';
  if(preference==='auto')whySize+=' With no species preference, we select Elk.';
  return {product:chosen,explanation:whySize+' '+whyCut,substitution};
 }
 window.K9ChooseChew=chooseChew;
 function init(scope=document) {
  scope.querySelectorAll('[data-menu-trigger]').forEach(button => {
   if(button.dataset.ready) return; button.dataset.ready='true';
   const drawer=document.getElementById(button.getAttribute('aria-controls'));
   if(!drawer) return;
   function close(){drawer.close();button.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');button.focus();}
   button.addEventListener('click',()=>{drawer.showModal();button.setAttribute('aria-expanded','true');document.body.classList.add('menu-open');});
   drawer.querySelector('[data-menu-close]')?.addEventListener('click',close);
   drawer.addEventListener('cancel',()=>{button.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');});
   drawer.addEventListener('close',()=>{button.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open');});
   drawer.addEventListener('click',e=>{if(e.target===drawer && e.offsetX<0) close();});
   drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>drawer.close()));
  });
  scope.querySelectorAll('[data-catalog]').forEach(catalog=>{
   if(catalog.dataset.ready) return;catalog.dataset.ready='true';
   const buttons=[...catalog.querySelectorAll('[data-cut-filter]')],cards=[...catalog.querySelectorAll('[data-product-cut]')];
   const count=catalog.querySelector('[data-product-count]');
   const filter=cut=>{buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cutFilter===cut)));let visible=0;cards.forEach(card=>{card.hidden=cut!=='all' && card.dataset.productCut!==cut;if(!card.hidden)visible++;});if(count)count.textContent=`${visible} ${visible===1?'chew':'chews'} shown`;};
   buttons.forEach(b=>b.addEventListener('click',()=>{filter(b.dataset.cutFilter);if(location.protocol.startsWith('http') && !document.body.dataset.standalone){const u=new URL(location.href);if(b.dataset.cutFilter==='all')u.searchParams.delete('cut');else u.searchParams.set('cut',b.dataset.cutFilter);history.replaceState({},'',u);}}));
   const initial=new URLSearchParams(document.body.dataset.standalone ? location.hash.split('?')[1] || '' : location.search).get('cut');if(['split','whole'].includes(initial))filter(initial);
  });
  scope.querySelectorAll('[data-fit-form]').forEach(form=>{
   if(form.dataset.ready)return;form.dataset.ready='true';
   const panel=form.closest('.fit-panel'),output=panel.querySelector('[data-fit-result]');
   const data=panel.querySelector('[data-fit-products]');
   const resultImage=output.querySelector('[data-fit-image]');
   resultImage.addEventListener('load',()=>{resultImage.hidden=false;});
   resultImage.addEventListener('error',()=>{resultImage.hidden=true;});
   let catalog=[];
   try { catalog=JSON.parse(data?.textContent||'[]').filter(p=>p&&p.title&&p.url&&p.key); }
   catch(error) { console.error('K-9 Antler Co. finder data could not be read.',error); }
   const reset=()=>{output.hidden=true;};
   form.addEventListener('input',reset);form.addEventListener('change',reset);
   form.addEventListener('submit',event=>{
    event.preventDefault();if(!form.reportValidity())return;
    const match=chooseChew(Number(form.elements.weight.value),form.elements.style.value,form.elements.species.value,catalog);
    const empty=panel.querySelector('[data-fit-empty]');
    if(!match){output.hidden=true;if(empty)empty.hidden=false;return;}
    if(empty)empty.hidden=true;
    const p=match.product;
    output.querySelector('[data-fit-title]').textContent=p.title;
    output.querySelector('[data-fit-specs]').textContent=`${p.species} / ${p.cut} / ${p.size}`;
    output.querySelector('[data-fit-text]').textContent=match.explanation;
    const substitution=output.querySelector('[data-fit-substitution]');
    substitution.textContent=match.substitution;substitution.hidden=!match.substitution;
    const link=output.querySelector('[data-fit-link]');link.href=p.url;
    link.setAttribute('aria-label',`View ${p.title}`);
    const image=output.querySelector('[data-fit-image]');
    image.hidden=true;if(p.image){image.src=p.image;image.alt=p.title;if(image.complete&&image.naturalWidth>0)image.hidden=false;}
    const price=output.querySelector('[data-fit-price]');
    price.textContent=p.priceDisplay||'';price.hidden=!p.priceDisplay;
    const availability=output.querySelector('[data-fit-availability]');
    availability.textContent=p.available===false?'Currently sold out. View this chew for stock updates.':p.available===true?'Available to order':'See the product page for current price and availability.';
    output.hidden=false;output.focus({preventScroll:true});
    output.scrollIntoView({block:'nearest',behavior:'auto'});
   });
  });
  scope.querySelectorAll('[data-gallery]').forEach(gallery=>{
   if(gallery.dataset.ready)return;gallery.dataset.ready='true';
   gallery.querySelectorAll('[data-gallery-target]').forEach(button=>button.addEventListener('click',()=>{
    gallery.querySelectorAll('[data-gallery-target]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    gallery.querySelectorAll('.gallery-panel').forEach(panel=>{panel.hidden=panel.id!==button.dataset.galleryTarget;if(panel.hidden)panel.querySelectorAll('video').forEach(v=>v.pause());});
   }));
  });
  scope.querySelectorAll('[data-variant-select]').forEach(select=>{
   if(select.dataset.ready)return;select.dataset.ready='true';
   select.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('variant',select.value);u.searchParams.delete('selling_plan');location.assign(u.toString());});
  });
  scope.querySelectorAll('[data-plan-select]').forEach(select=>{
   if(select.dataset.ready)return;select.dataset.ready='true';
   const productRoot=select.closest('[data-product-root]');
   const update=()=>{const selected=select.selectedOptions[0];const price=productRoot?.querySelector('[data-current-price]');const compare=productRoot?.querySelector('[data-compare-price]');if(price && selected?.dataset.price)price.textContent=selected.dataset.price;if(compare){compare.hidden=!selected?.dataset.compare;if(!compare.hidden)compare.textContent=selected.dataset.compare;}const u=new URL(location.href);if(select.value)u.searchParams.set('selling_plan',select.value);else u.searchParams.delete('selling_plan');history.replaceState({},'',u);};
   select.addEventListener('change',update);
  });
  scope.querySelectorAll('[data-online-form]').forEach(form=>{
   if(form.dataset.ready)return;form.dataset.ready='true';
   form.addEventListener('submit',event=>{if(location.protocol==='file:' || ['localhost','127.0.0.1'].includes(location.hostname)){event.preventDefault();let status=form.querySelector('[data-local-status]');if(status){status.hidden=false;status.textContent='This preview has not sent your message. Deploy the folder to Netlify with form detection enabled, or email support@k9antler.com.';status.focus();}}});
  });
  scope.querySelectorAll('img').forEach(img=>{
   if(img.dataset.ready)return;img.dataset.ready='true';
   img.addEventListener('error',()=>{if(img.dataset.fallback && img.src!==img.dataset.fallback){img.srcset='';img.src=img.dataset.fallback;}else img.closest('.media')?.classList.add('image-unavailable');});
   img.addEventListener('load',()=>img.closest('.media')?.classList.remove('image-unavailable'));
   if(img.complete && img.naturalWidth===0 && img.src)img.dispatchEvent(new Event('error'));
  });
 }
 window.K9Init=init;
 document.addEventListener('DOMContentLoaded',()=>init());
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
